import React, { useEffect, useState } from 'react';
import API from '../../services/api';
import { CMS_IMPRESSION_VIEWS } from '../../analyticsWidgets/cms';
import { buildCmsImpressionsRequest, getCmsImpressionsTableData, getCmsSelectedSites } from '../../utils/analytics/cmsImpressions';
import { getWidgetOptions } from '../../utils/widgets';

const CmsImpressionsWidget = ({ widget, filters, project, lastUpdated }) => {
  const [result, setResult] = useState({});
  const definition = CMS_IMPRESSION_VIEWS.find(view => view.id === widget.viewId);
  // An explicit empty UI selection must not accidentally request all authorized sites.
  const includesVendor = values => !values?.length || values.some(value =>
    !value.cmsId || value.cmsId === widget.cmsId);
  const canRequest = includesVendor(filters.selectedAdvertisers) && includesVendor(filters.selectedMedias) &&
    widget.cmsTemplateId &&
    project?.id && filters?.startDate && filters?.endDate &&
    getCmsSelectedSites(filters.selectedSites, widget.cmsId).length > 0;
  const request = canRequest ? buildCmsImpressionsRequest({
    projectId: project.id, templateId: widget.cmsTemplateId, cmsId: widget.cmsId, filters
  }) : null;
  const requestKey = JSON.stringify([widget.viewId, request, lastUpdated]);

  useEffect(() => {
    const [viewId, payload] = JSON.parse(requestKey);
    if (!payload) return undefined;
    let active = true;
    API.getAnalyticsViewData(viewId, payload).then(response => {
      if (active) setResult({ key: requestKey, response });
    }).catch(error => {
      if (active) setResult({ key: requestKey, error: error?.message || 'Failed to load CMS impressions.' });
    });
    return () => { active = false; };
    // The key includes every field sent to the API and the explicit refresh trigger.
  }, [requestKey]);

  const current = result.key === requestKey ? result : {};
  return (
      <widget-container
        id={widget.id}
        style={{ width: '100%', minWidth: 0, flex: '1 1 100%' }}
        widget-title={widget.title}
        display="table"
        data={JSON.stringify(getCmsImpressionsTableData(current.response, widget.fields))}
        config={JSON.stringify(definition?.config)}
        plot-options={JSON.stringify(definition?.plotOptions)}
        options={getWidgetOptions(widget)}
        is-loading={Boolean(request && !current.response && !current.error)}
      >
        {/* Keep the slotted node mounted: the web component relocates it into its header. */}
        <span slot="header-left" role="alert" className="small">{current.error || ''}</span>
      </widget-container>
  );
};

export default CmsImpressionsWidget;
